import DocumentsList from './_DocumentsList';

export default DocumentsList;
